export default __webpack_public_path__ + "static/media/careteam_patient_records_doctor.3f16629b.svg";